module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.75371f5.ttf";